export const CHICKEN = 'chicken'
export const DOG = 'dog'
export const CAT = 'cat'
export const MIXED = 'mixed'
export const KIBBLES = 'kibble'
export const WETFOOD = 'wetFood'
export const BOTH = 'both'
export const FISH = 'fish'
export const FEMALE = 'female'
export const PAYPAL = 'paypal'
export const IDLE = 'idle'
export const LOADING = 'loading'
export const SUCCESS = 'success'
export const FAILURE = 'failure'
export const SUBMIT = 'submit'
export const TRIAL = 'trial'
export const SHORT_DELAY = 2500
export const LONG_DELAY = 5000
export const EDITING_MODE_CREATION = 'creation-mode'
export const EDITING_MODE_UPDATE = 'updating-mode'
export const ACTIVE = 'active'
export const INACTIVE = 'inactive'

export const DOG_FISH_IMAGE_ID = '/snoopy/images/dog-fish-pack_qzuui3'
export const DOG_CHICKEN_IMAGE_ID = '/snoopy/images/dog-chicken-pack_htsbwe'
export const CAT_FISH_IMAGE_ID = '/snoopy/images/cat-fish-pack_qr7nug'
export const CAT_CHICKEN_IMAGE_ID = '/snoopy/images/cat-chicken-pack_m07kvc'
export const CAT_WETFOOD_IMAGE_ID = '/snoopy/images/cat-fish-wetFood_v1os9i'

export const kibblesImages = {
  [DOG]: {
    [CHICKEN]: DOG_CHICKEN_IMAGE_ID,
    [FISH]: DOG_FISH_IMAGE_ID,
  },
  [CAT]: {
    [CHICKEN]: CAT_CHICKEN_IMAGE_ID,
    [FISH]: CAT_FISH_IMAGE_ID,
  },
}

export const ADDING_PRODUCT_STATE = 'adding'
export const INITIAL_STATE = 'initial'
export const REMOVING_PRODUCT_STATE = 'deleting'
export const MODIFYING_PRODUCT_STATE = 'modifying'
export const UPSELL_SERVICE_TYPE = 'upsell'
export const CUSTOM_FOOD_SERVICE_TYPE = 'custom_food'

export const SUCCEEDED = 'succeeded'
export const FAILED = 'failed'
export const REFUNDED = 'refunded'
export const CANCELLED = 'cancelled'
export const PENDING = 'pending'

export const TWO_PETS_OFFER_DISCOUNT_PERCENTAGE = 20
export const MULTI_PETS_OFFER_DISCOUNT_PERCENTAGE = 30

export const CATEGORY_LABEL_COLORS = {
  black_friday: 'black',
  best_sellers: 'blue',
  novelty: 'white',
  sales: 'yellow',
  christmas: 'green',
}
